<template>
    <div class="engine-index-box">
        <div class="top-data-box">
            <div class="data-item data-item-1 clickable-card" @click="goUniPromotion">
                <div>
                    <p>新增广告</p>
                    <div class="data-value">{{ totalData.AD_COUNT || 0 }}</div>
                </div>
                <i class="el-icon-folder-add icon"></i>
            </div>
            <div class="data-item data-item-2 clickable-card" @click="goDashboardDetail('consumption')">
                <div>
                    <p>整体消耗</p>
                    <div class="data-value">{{ formatAmount(totalData.totalConsumption) }}</div>
                </div>
                <i class="el-icon-pie-chart icon"></i>
            </div>
            <div class="data-item data-item-3 clickable-card" @click="goDashboardDetail('amount')">
                <div>
                    <p>整体成交金额</p>
                    <div class="data-value">{{ formatAmount(totalData.totalGmv) }}</div>
                </div>
                <i class="el-icon-shopping-cart-full icon"></i>
            </div>
            <div class="data-item data-item-4 clickable-card" @click="goDashboardDetail('roi')">
                <div>
                    <p>支付ROI</p>
                    <div class="data-value">{{ formatAmount(totalData.avgRoi) }}</div>
                </div>
                <i class="el-icon-wallet icon"></i>
            </div>
        </div>

        <div class="warning-card" :class="{ active: violationSummary.activeViolationCount > 0 || violationSummary.fetchFailedCount > 0 }">
            <div class="warning-card-left">
                <div class="warning-title">
                    <i class="el-icon-warning-outline"></i>
                    扣分风险提醒
                </div>
                <div class="warning-main">
                    当前发现 {{ violationSummary.impactedAdvertiserCount || 0 }} 个风险账户，
                    共 {{ violationSummary.activeViolationCount || 0 }} 条待处理违规事件。
                </div>
                <div class="warning-sub">
                    已成功扫描：{{ violationSummary.checkedAccountCount || 0 }} / {{ violationSummary.totalAccountCount || 0 }}
                    <span v-if="violationSummary.fetchFailedCount">，失败账户数：{{ violationSummary.fetchFailedCount }}</span>
                </div>
            </div>
            <div class="warning-card-right">
                <el-button type="danger" @click="goViolationPage">查看详情</el-button>
                <el-button plain @click="goMessageCenter">消息中心</el-button>
                <el-button type="primary" plain @click="goCostOverview">消耗总览</el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'engineIndex',
    data() {
        return {
            totalData: {
                AD_COUNT: 0,
                avgRoi: 0,
                totalConsumption: 0,
                totalGmv: 0
            },
            violationSummary: {
                totalAccountCount: 0,
                checkedAccountCount: 0,
                impactedAdvertiserCount: 0,
                activeViolationCount: 0,
                fetchFailedCount: 0,
                lastSyncTime: ''
            }
        }
    },
    created() {
        this.getIndexData()
        this.getAdCountData()
        this.getViolationSummary()
    },
    methods: {
        getIndexData() {
            const date = new Date()
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const todayTime = `${year}-${month}-${day}`

            this.$axios.post({
                url: '/qianchuanCostOverview/dashboardSummary',
                data: {
                    startTime: todayTime,
                    endTime: todayTime,
                    onlyWithConsumption: 1,
                    pageIndex: 1,
                    pageSize: 10
                },
                success: (res) => {
                    if (res.code === 0 && res.data) {
                        this.totalData = Object.assign({}, this.totalData, {
                            totalConsumption: res.data.totalConsumption,
                            totalGmv: res.data.totalAmount,
                            avgRoi: res.data.avgRoi
                        })
                        return
                    }
                    this.$message.error(res.msg || '加载首页数据失败')
                },
                error: () => {
                    this.$message.error('加载首页数据失败')
                }
            })
        },
        getAdCountData() {
            const date = new Date()
            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const todayTime = `${year}-${month}-${day}`

            this.$axios.get({
                url: '/uniPromotion/getOverallOrderSummary/' + todayTime,
                loading: false,
                success: (res) => {
                    if (res.code === 0 && res.data) {
                        this.totalData = Object.assign({}, this.totalData, {
                            AD_COUNT: res.data.AD_COUNT || 0
                        })
                    }
                }
            })
        },
        getViolationSummary() {
            this.$axios.get({
                url: '/qianchuanViolationMonitor/summary',
                loading: false,
                success: (res) => {
                    if (res.code === 0 && res.data) {
                        this.violationSummary = Object.assign({}, this.violationSummary, this.pickMonitorSummary(res.data))
                    }
                }
            })
        },
        pickMonitorSummary(data) {
            return {
                totalAccountCount: data.totalAccountCount,
                checkedAccountCount: data.checkedAccountCount,
                impactedAdvertiserCount: data.impactedAdvertiserCount,
                activeViolationCount: data.activeViolationCount,
                fetchFailedCount: data.fetchFailedCount,
                lastSyncTime: data.lastSyncTime
            }
        },
        goViolationPage() {
            this.$router.push('/qdd/admin/violationPointsRecord.html')
        },
        goMessageCenter() {
            this.$router.push('/qdd/admin/ViolationMessageCenter.html')
        },
        goCostOverview() {
            this.$router.push('/qdd/admin/QianchuanCostOverview.html')
        },
        goDashboardDetail(metricType) {
            this.$router.push({
                path: '/qdd/admin/QianchuanCostOverview.html',
                query: {
                    metricType: metricType,
                    autoOpenDetail: '1',
                    startDate: this.currentDate,
                    endDate: this.currentDate,
                    _t: String(Date.now())
                }
            })
        },
        goUniPromotion() {
            this.$router.push({
                path: '/qdd/admin/uniPromotion.html',
                query: {
                    quickSource: 'engineIndex',
                    quickDate: 'today',
                    quickSelectMode: 'all',
                    _t: String(Date.now())
                }
            })
        },
        formatAmount(value) {
            return Number(value || 0).toFixed(2)
        }
    }
}
</script>

<style scoped>
.engine-index-box {
    min-height: 100vh;
    background: #f3f6fb;
    padding: 30px;
    box-sizing: border-box;
}

.top-data-box {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 18px;
}

.data-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 150px;
    border-radius: 18px;
    padding: 22px 28px;
    box-sizing: border-box;
    box-shadow: 0 12px 30px rgba(15, 35, 95, 0.06);
}

.clickable-card {
    cursor: pointer;
}

.data-item p {
    margin: 0;
    color: #6a7180;
}

.data-value {
    margin-top: 14px;
    font-size: 30px;
    font-weight: 700;
    color: #1f2a44;
}

.icon {
    font-size: 42px;
}

.data-item-1 {
    background: linear-gradient(135deg, #f3f9ff, #ffffff);
    border-top: 6px solid #618afd;
}

.data-item-1 .icon {
    color: #618afd;
}

.data-item-2 {
    background: linear-gradient(135deg, #fffaf0, #ffffff);
    border-top: 6px solid #f9b469;
}

.data-item-2 .icon {
    color: #f9b469;
}

.data-item-3 {
    background: linear-gradient(135deg, #f8f5ff, #ffffff);
    border-top: 6px solid #8816fd;
}

.data-item-3 .icon {
    color: #8816fd;
}

.data-item-4 {
    background: linear-gradient(135deg, #f1fbff, #ffffff);
    border-top: 6px solid #3bb6d5;
}

.data-item-4 .icon {
    color: #3bb6d5;
}

.warning-card {
    margin-top: 22px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding: 22px 24px;
    border-radius: 18px;
    background: linear-gradient(135deg, #fff9f7, #ffffff);
    border: 1px solid #ffd6cc;
    box-shadow: 0 12px 30px rgba(15, 35, 95, 0.06);
}

.warning-card.active {
    border-color: #f56c6c;
    background: linear-gradient(135deg, #fff0ed, #ffffff);
}

.warning-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 18px;
    font-weight: 700;
    color: #1f2a44;
}

.warning-main {
    margin-top: 12px;
    font-size: 16px;
    color: #444c5c;
}

.warning-sub {
    margin-top: 8px;
    font-size: 13px;
    color: #8a93a6;
}

.warning-card-right {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

@media (max-width: 1200px) {
    .top-data-box {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 768px) {
    .engine-index-box {
        padding: 18px;
    }

    .top-data-box {
        grid-template-columns: 1fr;
    }

    .warning-card {
        flex-direction: column;
        align-items: flex-start;
    }

    .warning-card-right {
        width: 100%;
    }

    .warning-card-right /deep/ .el-button {
        flex: 1;
        min-width: 140px;
    }
}
</style>
